<template>
    <div>
        <el-tabs type="border-card" v-model="activeName">
            <el-tab-pane label="详情信息" name="1">
                <el-form  ref="formData" :model="formData" label-width="150px">
                    <el-form-item label="姓名：">
                        <el-input v-model="formData.name" maxlength="50" placeholder="请输入姓名" style="width: 60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="公司：">
                        <el-input v-model="formData.company" maxlength="50" placeholder="请输入公司名称" style="width: 60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="邮件：">
                        <el-input v-model="formData.email" maxlength="50" placeholder="请输入邮件地址" style="width: 60%;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formData.tel" maxlength="50" placeholder="请输入电话号码" style="width: 60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="QQ：">
                        <el-input v-model="formData.qq" maxlength="50" placeholder="请输入QQ账号" style="width: 60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="微信：">
                        <el-input v-model="formData.wechat" maxlength="50" placeholder="请输入微信号" style="width: 60%;" ></el-input>
                    </el-form-item>
                    <el-form-item label="" style="text-align: center;">
                        <el-button type="primary" size="small" @click="reviewlication" :disabled="disabled">确认修改</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import * as api from "@/api/auth/register";
export default {
    components: {},
    data() {
        return {
            activeName: "1",
            disabled: false,
            formData: {},
            checked: false,
            checked1: false,
            checked2: false,
            list: [],
            loading: false
        };
    },
    methods: {
        reviewlication() {
            this.disabled = true;
            api.profileSave(this.formData)
                .then(res => {
                    if (res.code === 0) {
                        this.disabled = false;
                        this.$message({
                            message: "个人信息修改成功",
                            type: "success"
                        });
                        this.$router.go(-1);
                    } else {
                        this.disabled = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        }
    },
    created() {
        api.profileIndex().then(res => {
            if (res.code === 0) {
                this.formData = res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.message
                });
            }
        });
    }
};
</script>

<style type="text/scss" lang="scss">
.check_limit_switch {
    font-family: "微软雅黑";
    color: #767676;
}
</style>
